import AdminDashboard from "./AdminDashboard";


const alldashboardRoutes = [
    {
        path: "",
        component: <AdminDashboard />,
    },

];

const dashboardListRoute = {
    path: "dashboardList",
    component: <AdminDashboard />,
};



export default alldashboardRoutes;

export { dashboardListRoute };